import { render, staticRenderFns } from "./BaseAttributeValueList.vue?vue&type=template&id=1de55e5c&scoped=true&"
import script from "./BaseAttributeValueList.vue?vue&type=script&lang=js&"
export * from "./BaseAttributeValueList.vue?vue&type=script&lang=js&"
import style0 from "./BaseAttributeValueList.vue?vue&type=style&index=0&id=1de55e5c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de55e5c",
  null
  
)

export default component.exports